import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Pagination as MuiPagination } from "@material-ui/lab";

const useStyles = makeStyles(theme => ({
  pagination: {
    display: "flex",
    justifyContent: "center"
  }
}));

const Pagination = ({ currentPage, numPages, navigate, section }) => {
  const classes = useStyles();
  const [page, setPage] = useState(currentPage || 1);
  const smallScreen = useMediaQuery("(max-width:600px)");
  const handleChange = (section, value) => {
    if (value > 1) {
      setPage(value);
      return navigate(`/${section}/${value}`);
    }
    setPage(1);
    return navigate(`/${section}/`);
  };
  if (numPages < 2) return null;
  return (
    <div className={classes.pagination}>
      <MuiPagination
        page={page}
        count={numPages}
        size={smallScreen ? "small" : "medium"}
        onChange={(_, value) => handleChange(section, value)}
      />
    </div>
  );
};

export default Pagination;
